import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";

import { Provider, useSelector } from 'react-redux';
import {store} from './store'

import global_en from './translations/en/global.json' 
import settings_en from './translations/en/settings.json' 
import global_ar from './translations/ar/global.json' 
import settings_ar from './translations/ar/settings.json' 
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';

const I18nWrapper = () => {
  const [i18nReady, setI18nReady] = useState(false);
  const currentLang = useSelector((state) => state.lang.value); 

  // Set initial direction immediately to prevent flicker
  useEffect(() => {
    const initialLang = currentLang || 'en';
    const dir = initialLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = initialLang;
    document.body.dir = dir;
    document.body.classList.remove('rtl', 'ltr');
    document.body.classList.add(dir);
  }, []);

  useEffect(() => {
    const initI18n = async () => {
      await i18next.init({
        interpolation:{ escapeValue: false},
        lng: currentLang || 'en',
        resources:{
          en:{
            global:global_en,
            settings:settings_en,
          },
          ar:{
            global:global_ar,
            settings:settings_ar,
          },
        },
        fallbackLng: 'en',
        detection: {
          order: ['navigator', 'htmlTag', 'cookie', 'localStorage'],
        },
        react: {
          useSuspense: false
        }
      });
      setI18nReady(true);
    };
    initI18n();
  }, []);

  useEffect(() => {
    if (i18nReady) {
      const nextLang = currentLang || 'en';
      i18next.changeLanguage(nextLang);
      const dir = nextLang === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.dir = dir;
      document.documentElement.lang = nextLang;
      document.body.dir = dir;
      document.body.classList.remove('rtl', 'ltr');
      document.body.classList.add(dir);
    }
  }, [currentLang, i18nReady]);

  if (!i18nReady) return null;

  return (
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  );
};

const Root = () => (
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <I18nWrapper />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
